import { useBreadcrumb } from "features/breadcrumbs";
import ListaPostagens from "./components/ListaPostagens";
import Container from "components/Container";

function MuralListagemPage() {
  useBreadcrumb([{ name: "Administração" }, { name: "Mural" }]);

  return (
    <Container>
      <ListaPostagens />
    </Container>
  );
}

export default MuralListagemPage;
